<div class="auth-container flex h-screen">
    <!-- LEFT SIDE: three brand-coloured waves under the welcome text -->
    <div class="welcome relative w-4 overflow-hidden hidden md:block">
        @for (wave of waves; track wave) {
            <svg
                class="wave absolute inset-0 w-10 h-full"
                [class]="'wave--' + wave"
                viewBox="1 1 1026 1777"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="none"
                aria-hidden="true">
                <path
                    d="M837.398 970.884C583.225 671.558 712.275 407.238 980.954 1H1V1777H980.954C1048.8 1571.6 1067.25 1241.57 837.398 970.884Z" />
            </svg>
        }
        <div class="welcome__text">
            <h2 class="welcome__title">{{ 'home.onboarding.welcome.title' | translate }}</h2>
            <p class="welcome__subtitle">{{ 'home.onboarding.welcome.subtitle' | translate }}</p>
            <ul class="welcome__features">
                @for (feature of features; track feature.key; let last = $last) {
                    <li class="welcome__feature">
                        <span class="material-symbols-outlined icon-md" aria-hidden="true">{{ feature.icon }}</span>
                        <div class="flex flex-column">
                            <span>{{ 'home.onboarding.welcome.features.' + feature.key | translate }}</span>
                            @if (feature.arrow) {
                                <img class="welcome__arrow" [src]="feature.arrow" alt="" />
                            }
                        </div>
                    </li>
                }
            </ul>
            <p-button
                severity="secondary"
                [label]="'home.onboarding.welcome.contact' | translate"
                (onClick)="sendEmail()" />
        </div>
    </div>
    <!-- RIGHT SIDE -->
    <div class="right-side w-full md:w-8">
        <!-- AUTHENTICATION SECTION -->
        <div class="body w-full h-full flex align-items-center md:align-items-start justify-content-center flex-column">
            <app-language-selector
                [selectedLocale]="selectedLocale"
                class="absolute top-0 mt-3 right-0 mr-3"></app-language-selector>
            <div class="auth-body flex flex-column">
                <img src="assets/images/logo/logo-h.webp" alt="quickscan-logo" class="auth-logo w-20rem" />

                <div>
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
        <!-- FOOTER SECTION -->
        <div class="footer flex justify-content-between align-items-center m-3 mb-1 w-full">
            <img
                src="assets/images/logo/logo-provider.webp"
                class="auth-footer-brand w-10rem h-auto"
                alt="Provider logo" />
            <span class="text-sm text-color-secondary text-center">{{
                'authentication.common.footer.copyright' | translate: { year: currentYear }
            }}</span>
            <div class="flex flex-column gap-3 text-sm text-color-secondary md:flex-row">
                <a href="https://d-carbonize.eu/release-notes/" target="_blank"
                    >{{ 'common.version' | translate }} {{ currentAppVersion }}</a
                >
                <a class="footer__bug" href="mailto:scan@d-carbonize.eu" target="_blank">{{
                    'common.bug' | translate
                }}</a>
            </div>
        </div>
    </div>
</div>
